// extracted by mini-css-extract-plugin
module.exports = {"mobileCardContainer":"style_mobileCardContainer__fTuEi","wrapper":"style_wrapper__pO_xT","cardContainer":"style_cardContainer__GNM_N","activeCard":"style_activeCard__tosO4"};